// Calendar helpers: produce Google Calendar URL + iCal (.ics) blob for an event.
// Events in this app store dates as ISO strings (YYYY-MM-DD), treated as all-day.

function toCalDate(isoDate) {
    // YYYY-MM-DD -> YYYYMMDD
    return isoDate.replaceAll("-", "");
}

function addDays(isoDate, days) {
    const d = new Date(`${isoDate}T00:00:00Z`);
    d.setUTCDate(d.getUTCDate() + days);
    return d.toISOString().slice(0, 10);
}

function escapeICS(text = "") {
    return String(text)
        .replace(/\\/g, "\\\\")
        .replace(/\n/g, "\\n")
        .replace(/,/g, "\\,")
        .replace(/;/g, "\\;");
}

export function googleCalendarUrl(event) {
    const start = toCalDate(event.start_date);
    // End date is exclusive for all-day events on Google Calendar
    const endSource = event.end_date || event.start_date;
    const end = toCalDate(addDays(endSource, 1));

    const details = [
        event.description,
        event.organizer ? `Organizer: ${event.organizer}` : "",
        event.url ? `More info: ${event.url}` : "",
        `Gender: ${event.gender} · Age: ${event.age_range} · Type: ${event.event_type}`,
    ]
        .filter(Boolean)
        .join("\n\n");

    const location = [event.venue, event.city, event.county, "Virginia"]
        .filter(Boolean)
        .join(", ");

    const params = new URLSearchParams({
        action: "TEMPLATE",
        text: event.title,
        dates: `${start}/${end}`,
        details,
        location,
    });
    return `https://www.google.com/calendar/render?${params.toString()}`;
}

export function downloadIcs(event) {
    const start = toCalDate(event.start_date);
    const endSource = event.end_date || event.start_date;
    const end = toCalDate(addDays(endSource, 1));
    const now = new Date()
        .toISOString()
        .replace(/[-:]/g, "")
        .replace(/\.\d+/, "");

    const location = [event.venue, event.city, event.county, "Virginia"]
        .filter(Boolean)
        .join(", ");

    const description = [
        event.description,
        event.organizer ? `Organizer: ${event.organizer}` : "",
        `Gender: ${event.gender} | Age: ${event.age_range} | Type: ${event.event_type}`,
    ]
        .filter(Boolean)
        .join("\\n\\n");

    const ics = [
        "BEGIN:VCALENDAR",
        "VERSION:2.0",
        "PRODID:-//VA Lax HQ//EN",
        "CALSCALE:GREGORIAN",
        "METHOD:PUBLISH",
        "BEGIN:VEVENT",
        `UID:${event.id}@va-lax-hq`,
        `DTSTAMP:${now}`,
        `DTSTART;VALUE=DATE:${start}`,
        `DTEND;VALUE=DATE:${end}`,
        `SUMMARY:${escapeICS(event.title)}`,
        `DESCRIPTION:${description}`,
        `LOCATION:${escapeICS(location)}`,
        event.url ? `URL:${escapeICS(event.url)}` : "",
        "END:VEVENT",
        "END:VCALENDAR",
    ]
        .filter(Boolean)
        .join("\r\n");

    const blob = new Blob([ics], { type: "text/calendar;charset=utf-8" });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    const safeTitle = event.title
        .replace(/[^a-z0-9]+/gi, "-")
        .toLowerCase()
        .slice(0, 40);
    a.download = `${safeTitle || "event"}.ics`;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    URL.revokeObjectURL(url);
}
